import React from "react";
import cn from "classnames";
import { useFormControl } from "../FormControl";
import styles from "./FormError.module.scss";

interface FormErrorProps {
  message?: string;
  className?: string;
}

/**
 * FormError component
 *
 * Displays validation error messages for form fields.
 * Automatically gets the error from form context if not explicitly provided.
 */
const FormError: React.FC<FormErrorProps> = ({ message, className }) => {
  const { error } = useFormControl();

  if (!error && !message) {
    return null;
  }

  return (
    <span className={cn(styles.formError, className)}>{message || error}</span>
  );
};

export default FormError;
